// Types
import type { TSortableHeaderItem } from '~/misc/v-table-header-sortable/types';
import { EManagerCompanyPatchesSorting } from '~/modules/manager/types';

const TABLE_HEADERS: TSortableHeaderItem[] = [
  { label: 'Area name', key: EManagerCompanyPatchesSorting.NAME, sortable: true },
  { label: 'Districts and sectors', key: EManagerCompanyPatchesSorting.DISTRICTS, sortable: true },
  { label: 'Department', key: EManagerCompanyPatchesSorting.DEPARTMENT, sortable: true },
  { label: 'Users', key: EManagerCompanyPatchesSorting.USERS, sortable: true },
  { label: '', key: 'actions', sortable: false },
];

export { TABLE_HEADERS };
